import { Event } from '../app/(main)/events/[slug]/page.val';
import { EventSeries } from '../settings/eventSeries.val';

export function getAllActiveEvents(
  events: Record<string, Event>,
  eventSeries: Record<string, EventSeries>
): Record<string, Event> {
  return Object.fromEntries(
    Object.entries(events).filter(([, event]) => {
      return eventSeries[event.type].active;
    })
  );
}
